import React from "react";

export default function MagnetBenefitCard({
  title,
  description,
  image_url,
}: {
  title: string;
  description: string;
  image_url: string;
}) {
  return (
    <div className="mb-10 md:flex">
      <img
        className="h-24 w-24 rounded-xl border-1 border-white bg-black object-cover md:min-h-[100px] md:min-w-[100px]"
        src={image_url}
        alt=""
      />
      <div className="mt-2 md:ml-4">
        <h3 className="text-md mb-1 font-bold md:text-lg">{title}</h3>
        <p className="text-md opacity-75 md:text-lg ">{description}</p>
      </div>
    </div>
  );
}
